import { FC, useCallback } from 'react';
import { GetFilesDataItem } from 'services';
import { CoverImage, CoverImageProps } from '../CoverImage/CoverImage.component';

export interface CoverImageInputProps extends Omit<CoverImageProps, 'coverImage' | 'onChange'> {
  value?: GetFilesDataItem;
  onChange?: (value?: GetFilesDataItem) => void;
  disabled?: boolean;
}

const CoverImageInput: FC<CoverImageInputProps> = ({
  className,
  noCoverTitle,
  value,
  onChange = (_value?: GetFilesDataItem) => {},
  disabled,
  bottomComponent,
  title,
  readOnly,
  id,
  onFinish,
}) => {
  const handleOnChange = useCallback(
    (value?: GetFilesDataItem) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <CoverImage
      onFinish={onFinish}
      className={className}
      onChange={handleOnChange}
      noCoverTitle={noCoverTitle}
      coverImage={value}
      disabled={disabled}
      bottomComponent={bottomComponent}
      title={title}
      readOnly={readOnly}
      id={id}
    />
  );
};

export { CoverImageInput };
